import "../../components/ProfileCard/ProfileCard.scss";
import "./Payments.scss";
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {PATHS} from "../../../../../enum";
import {usePaymentsStore} from "../../../../../modules/profile/payments/store";
import Pagination from "../../../../shared/Pagination/Pagination";
import {formatDate, formatTime} from "../../../../shared/functions/formateDate";
import {CardHead} from "../../components/ProfileCard/ProfileCard";

const PAGE_SIZE = 6;

const STATUS: Record<string, { text: string, tone: "ok" | "wait" | "bad" }> = {
    success: { text: "Зараховано", tone: "ok" },
    pending: { text: "Очікує оплати", tone: "wait" },
    processing: { text: "Обробляється", tone: "wait" },
    review: { text: "Перевіряється", tone: "wait" },
    failed: { text: "Помилка", tone: "bad" },
    fail: { text: "Помилка", tone: "bad" },
};

const CURRENCY: Record<string, string> = { UAH: "₴", USD: "$", EUR: "€" };

// Історія поповнень: картка з кнопкою поповнення, нижче список платежів зі статусами
const Payments = () => {
    const payments = usePaymentsStore(state => state.payments)
    const totalItems = usePaymentsStore(state => state.totalItems)
    const fetchPayments = usePaymentsStore(state => state.fetchPayments)
    const [page, setPage] = useState(1)

    useEffect(() => { fetchPayments(page) }, [page])

    return (
        <div className="bc-page">
            <div className="bc-card">
                <CardHead
                    icon={
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="2" y="5" width="20" height="14" rx="3" />
                            <path d="M2 10h20" />
                            <path d="M6 15h4" />
                        </svg>
                    }
                    title="Платежі"
                    text="Тут видно всі ваші поповнення балансу та їхній статус."
                />
                <Link className="bc-submit pay-cta" to={PATHS.DEPOSIT}>Поповнити баланс</Link>
            </div>

            <div className="bc-list-card">
                <h4 className="bc-list-title">Історія поповнень</h4>
                { payments.length === 0
                    ? <div className="bc-empty">Поповнень ще не було</div>
                    : <div className="tr-list">
                        { payments.map((p: any) => {
                            const status = STATUS[String(p.status).toLowerCase()] ?? { text: p.status, tone: "wait" as const }
                            const sign = CURRENCY[p.currency] ?? p.currency
                            return (
                                <div key={p._id} className={`tr-row pay-${status.tone}`}>
                                    <span className="tr-dir" aria-hidden="true">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                                            { status.tone === "ok" && <path d="M5 12.5l4.5 4.5L19 7.5" /> }
                                            { status.tone === "wait" && <><circle cx="12" cy="12" r="8" /><path d="M12 8v4l2.5 1.5" /></> }
                                            { status.tone === "bad" && <path d="M7 7l10 10M17 7L7 17" /> }
                                        </svg>
                                    </span>
                                    <div className="tr-main">
                                        <span className="tr-who"><b className="pay-system">{p.paymentSystem}</b> · <span className={`pay-status pay-status-${status.tone}`}>{status.text}</span></span>
                                        <span className="tr-date">{formatDate(p.createdAt)} · {formatTime(p.createdAt)}</span>
                                    </div>
                                    <div className="pay-sum">
                                        <span className="tr-amount">+{p.amount} {sign}</span>
                                        { p.bonus > 0 && <span className="pay-bonus">бонус +{p.bonus} ₴</span> }
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                }
                { totalItems > PAGE_SIZE && <Pagination totalItems={totalItems} active={page} setActive={setPage} /> }
            </div>
        </div>
    );
};

export default Payments;
